module.exports = __webpack_public_path__ + "static/media/Koblenz.147b4c08.jpg";